// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 45738 ? "43b65290" : chunkId) + "." + {"25239":"0174bbebc7bd899d","35767":"3b40bec78faf03d4","45738":"f82b1bd002bc680b","87743":"3b4cf462e09d15b1"}[chunkId] + ".js";
};